"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var styled_components_1 = tslib_1.__importStar(require("styled-components"));
var types_1 = require("./types");
var variantStyle = function (_a) {
    var _b;
    var thickness = _a.thickness, color = _a.color, _c = _a.spacing, spacing = _c === void 0 ? '0px' : _c;
    return (_b = {},
        _b[types_1.Variant.VERTICAL] = styled_components_1.css(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n\t\tdisplay: inline-flex;\n\t\tborder-left: ", " solid ", ";\n\t\tmargin: 0 ", ";\n\t\theight: 100%;\n\t"], ["\n\t\tdisplay: inline-flex;\n\t\tborder-left: ", " solid ", ";\n\t\tmargin: 0 ", ";\n\t\theight: 100%;\n\t"])), thickness, color, spacing),
        _b[types_1.Variant.HORIZONTAL] = styled_components_1.css(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n\t\tborder-top: ", " solid ", ";\n\t\tmargin: ", " 0;\n\t\twidth: 100%;\n\t"], ["\n\t\tborder-top: ", " solid ", ";\n\t\tmargin: ", " 0;\n\t\twidth: 100%;\n\t"])), thickness, color, spacing),
        _b);
};
function applyStyles(props) {
    var variant = props.variant, rest = tslib_1.__rest(props, ["variant"]);
    return variantStyle(tslib_1.__assign({}, rest))[variant];
}
exports.StyledSeparator = styled_components_1.default.div(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n\t", ";\n"], ["\n\t", ";\n"])), applyStyles);
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=styled.js.map